/*
 * @Description: 订单管理
 * @Author: gao shuai
 * @Date: 2020-05-15 18:07:30
 * @LastEditTime: 2020-05-16 17:40:27
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 分组下拉
  async gameTeam(params) {
  return api({ url: '/api/SelectDropDown/GetGroupNameNameListAsync', method: 'get', params });
  },
  // 分区下拉
  async gamearea(params) {
  return api({ url: '/api/SelectDropDown/GetPartitionNameListAsync', method: 'get', params });
  },
  // 支付方式下拉
  async paylist(params) {
  return api({ url: '/api/SelectDropDown/GetPayModeNameListAsync', method: 'get', params });
  },
  // 订单管理列表
  async orderlist(params) {
  return api({ url: '/api/Orders/GetTenantOrdersListAsync', method: 'get', params });
  },
  // 昨天充值
  async yesterdayCharge(params) {
  return api({ url: '/api/Orders/GetOrdersYesterdayListAsync', method: 'get', params });
  },
  // 今天充值
  async todayCharge(params) {
  return api({ url: '/api/Orders/GetOrdersTodayListAsync', method: 'get', params });
  },
  // 订单详情
  async orderDetail(params) {
  return api({ url: '/api/Orders/GetOrderDetailAsync', method: 'get', params });
  }
};
